import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconRatingStar';
/** Renders an SVG icon. */
const SvgRatingStar = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" data-icon="true" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.615 3.726c.512-1.232 2.258-1.232 2.77 0l3.007 7.23 7.804.625c1.33.107 1.87 1.766.856 2.634l-5.946 5.094 1.817 7.616c.31 1.298-1.102 2.323-2.241 1.628L16 24.472l-6.682 4.081c-1.138.695-2.55-.33-2.24-1.628l1.816-7.616-5.946-5.094c-1.014-.868-.474-2.527.856-2.634l7.804-.626zM16 5.604l-2.662 6.401a1.5 1.5 0 0 1-1.265.92l-6.911.553 5.265 4.51a1.5 1.5 0 0 1 .483 1.488L9.302 26.22l5.916-3.614a1.5 1.5 0 0 1 1.564 0l5.916 3.614-1.608-6.744a1.5 1.5 0 0 1 .483-1.487l5.265-4.51-6.91-.555a1.5 1.5 0 0 1-1.265-.919z"
        clipRule="evenodd"
      />
    </svg>
  );
};
SvgRatingStar.displayName = displayName;
export default SvgRatingStar;
